import { Box } from '@mui/material';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import classes from 'components/widgets/ImageUploader/component/Image/Image.module.scss';

export type ImageProps = {
    imageUrl: string;
    imageFile?: File | null;
    showRemoveIcon?: boolean;
    onRemove?: () => void;
};

export const Image = ({ imageUrl, imageFile, showRemoveIcon, onRemove }: ImageProps) => {
    return (
        <Box className={classes.imageWrapper}>
            {showRemoveIcon && onRemove && (
                <button type={'button'} className={classes.removeImage} onClick={onRemove} aria-label={'Remove image'}>
                    <MuiIcon
                        icon={'delete'}
                        type={'round'}
                        fontSize={'4rem'}
                        color={'var(--button-primary-bg_destructive)'}
                    />
                </button>
            )}
            <Box component={'img'} className={classes.image} src={imageUrl} alt={imageFile?.name || 'Selected image'} />
        </Box>
    );
};
